import { useEffect } from 'react';
import { useLogout, useRedirect } from 'react-admin';
import authProvider from '../auth/authProvider';
import { DASHBOARD_MODULE_ROLES, WHATSAPP_MODULE_ROLES } from '../roles/portalRoles';
import { UserRole } from '../types/types';
import { isTokenExpired } from '../utils/jwtUtils';

const MarketingHome = () => {
  const redirect = useRedirect();
  const logout = useLogout();

  useEffect(() => {
    const token = localStorage.getItem('user_authToken');

    if (!token || isTokenExpired(token)) {
      logout();
      return;
    }

    const userRole = authProvider.getUserRole();

    if (userRole === UserRole.MarketingAdmin) {
      if (!authProvider.isRoleAuthorized(WHATSAPP_MODULE_ROLES)) {
        redirect('/not-authorized');
        return;
      }
      redirect('/messageinbox');
      return;
    }

    if (authProvider.isRoleAuthorized(DASHBOARD_MODULE_ROLES)) {
      redirect('/dashboard/customers');
      return;
    }

    redirect('/not-authorized');
  }, [logout, redirect]);

  return null;
};

export default MarketingHome;
